import styled from 'styled-components/macro';
import { DropdownSelect } from '../../../../../common/formElements';

export const StyledDropdownSelect = styled(DropdownSelect)`
  border-radius: 3px;
`;
